module.exports = __webpack_public_path__ + "static/media/default.eb637578.jpg";